import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Slider, { Settings } from 'react-slick';

import { SVGIconType } from '../../../../constants/svgIcon';
import { RewardReferralRole } from '../../../../models/RewardStore';
import { Profile } from '../../../../models/UserStore';
import {
  DefaultBackButton,
  JoyajoyImage,
  JoyajoyImageFile,
  SvgIcon,
} from '../../../Molecules';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './WebStoreProductDetailTemplate.module.css';

export type WebStoreProductDetailTemplateProps = {
  profile: Profile | undefined | null;
  rewardReferralRole: RewardReferralRole | undefined;
  userRewardReferralCode: string | undefined | null;
  carousel: JoyajoyImageFile[];
  productName: string | undefined;
  price: string | undefined;
  originalPrice: string | undefined;
  referralReward: string | undefined;
  description: string | undefined | null;
  shareButtonDisabled: boolean;
  purchaseButtonDisabled: boolean;
  purchaseButtonText: string;
  isSubscriptionExpired: boolean;
  subscriptionExpiredAt: Date | undefined;
  onClickLearnMore?: () => void;
  onClickShare?: () => void;
  onClickPurchase?: () => void;
  onClickEnterClub?: () => void;
  additionalDetails?: JSX.Element; // for adding bottom stuff
};

export const WebStoreProductDetailTemplate = memo(
  ({
    // profile,
    // rewardReferralRole,
    // userRewardReferralCode,
    carousel,
    productName,
    price,
    originalPrice,
    // referralReward,
    description,
    shareButtonDisabled,
    purchaseButtonDisabled,
    purchaseButtonText,
    isSubscriptionExpired,
    subscriptionExpiredAt,
    onClickLearnMore,
    onClickShare,
    onClickPurchase,
    onClickEnterClub,
    additionalDetails,
  }: WebStoreProductDetailTemplateProps) => {
    const { t, i18n } = useTranslation();

    const settings: Settings = {
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      adaptiveHeight: false,
    };

    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };

    const formattedDate = subscriptionExpiredAt
      ? new Intl.DateTimeFormat(i18n.language, options).format(
          subscriptionExpiredAt,
        )
      : undefined;

    return (
      <>
        <div className={styles.productDetail}>
          <div className={styles.userInfoContainer}>
            <DefaultBackButton />
            {/* <div className={styles.userAvatarContainer}>
                <AvatarNode profile={profile} size={50} />
              </div>
              <div className={styles.horizontalContainer}>
                <div className={styles.userName}>{profile.name}</div>
                {userRewardReferralCode && (
                  <div className={styles.distributorId}>
                    {`${t(
                      rewardReferralRole === RewardReferralRole.Partner
                        ? 'Partner ID: '
                        : 'Distributor ID: ',
                    )} ${userRewardReferralCode}`}
                  </div>
                )}
              </div> */}
          </div>

          <div className={styles.carouselContainer}>
            <Slider {...settings}>
              {carousel.map((src, index) => (
                <div key={index} className={styles.slideItem}>
                  <JoyajoyImage {...src} />
                </div>
              ))}
            </Slider>
          </div>
          <div className={styles.textArea}>
            <div className={styles.produceName}>{productName}</div>
            <div className={styles.priceContainer}>
              <div className={styles.priceRow}>
                {price !== undefined ? (
                  <div className={styles.productPrice}>{price}</div>
                ) : null}
                {originalPrice !== undefined ? (
                  <div className={styles.originalPrice}>{originalPrice}</div>
                ) : null}
              </div>
            </div>
            <div className={styles.description}>{description}</div>
            {onClickLearnMore && (
              <div className={styles.learnMoreContainer}>
                <div className={styles.learnMore} onClick={onClickLearnMore}>
                  {t('Learn More')}
                  <SvgIcon name={SVGIconType.Arrow} width={16} height={16} />
                </div>
              </div>
            )}
            <div className={styles.shareButtonContainer}>
              {onClickShare && (
                <button
                  className={`${styles.shareButton} ${
                    shareButtonDisabled ? styles.greyButton : ''
                  }`}
                  onClick={onClickShare}
                >
                  {t('Share & Refer')}
                </button>
              )}

              {/* {referralReward !== undefined ? (
                <div className={styles.refferalPrice}>
                  {t('Referral Reward:')}
                  {(!rewardReferralRole ||
                    rewardReferralRole === RewardReferralRole.Customer) && (
                    <img
                      src={Icons[IconType.Credit]}
                      className={styles.smallJoyCashIcon}
                    />
                  )}
                  {referralReward}
                </div>
              ) : null} */}

              {onClickPurchase && (
                <button
                  className={`${styles.shareButton} ${
                    purchaseButtonDisabled ? styles.greyButton : ''
                  }`}
                  onClick={onClickPurchase}
                >
                  {t(purchaseButtonDisabled ? 'Purchased' : purchaseButtonText)}
                </button>
              )}
            </div>

            <div className={styles.extraButtonContainer}>
              {formattedDate ? (
                <div
                  className={`${styles.itemExpireDate} ${
                    isSubscriptionExpired ? styles.expiredText : ''
                  }`}
                >{`${t(
                  isSubscriptionExpired ? 'Expired: ' : 'Expire on: ',
                )} ${formattedDate}`}</div>
              ) : null}

              {onClickEnterClub && (
                <div
                  className={styles.enterPurchaseClub}
                  onClick={onClickEnterClub}
                >
                  {t('Enter Purchased Club')}
                  <SvgIcon name={SVGIconType.Arrow} width={16} height={16} />
                </div>
              )}
            </div>
          </div>
        </div>
        {additionalDetails}
      </>
    );
  },
);
